var _excluded = ["ariaLabel", "children", "hideDivider", "label"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import useStyles from './use_styles';
import propTypes from './prop_types';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MenuSection = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      ariaLabel,
      children,
      hideDivider = false,
      label
    } = _ref,
    menuSectionProps = _objectWithoutProperties(_ref, _excluded);
  var style = useStyles({
    hasLabel: Boolean(label)
  });
  return ___EmotionJSX(React.Fragment, null, !hideDivider && ___EmotionJSX("li", {
    css: style.divider,
    role: "separator"
  }), ___EmotionJSX("li", _extends({
    ref: ref,
    role: "presentation"
  }, menuSectionProps), label && ___EmotionJSX("span", {
    "aria-hidden": true,
    css: style.label
  }, label), children && ___EmotionJSX("ul", {
    role: "group",
    "aria-label": ariaLabel || label
  }, children)));
});
MenuSection.propTypes = propTypes;
MenuSection.displayName = 'MenuSection';
export default MenuSection;